module.exports = __webpack_public_path__ + "img/quadro-about.bb1eca41.jpg";